import type { OrgRef } from '../store/authSlice';

/**
 * Pick which org to enter after OTP (or password auto-path).
 *
 * - When login showed org select (`defaultContextLogin === false`): use pendingOrgId
 *   if it is still a membership; otherwise return null → manual org-picker.
 * - When login used default context (`defaultContextLogin === true`): never ask again —
 *   prefer lastOrgId if still a membership, else the first membership.
 */
export function resolvePostLoginOrgId(
  memberships: OrgRef[],
  opts: {
    showOrgSelectOnLogin: boolean;
    pendingOrgId: string | null | undefined;
    lastOrgId: string | null | undefined;
  },
): string | null {
  if (!memberships.length) return null;
  const ids = memberships.map((m) => String(m.orgId));

  if (opts.showOrgSelectOnLogin) {
    const pending = opts.pendingOrgId != null ? String(opts.pendingOrgId) : '';
    if (pending && ids.includes(pending)) return pending;
    return null;
  }

  const last = opts.lastOrgId != null ? String(opts.lastOrgId) : '';
  if (last && ids.includes(last)) return last;
  return ids[0] ?? null;
}
